import {Action} from '@ngrx/store';
import {Antrag} from '@wba/models/antrag';

export enum AntragActionTypes {
  ANTRAG_LOAD = '[Antrag] Load',
  ANTRAG_LOAD_SUCCESS = '[Antrag] Load success',
  ANTRAG_LOAD_FAILED = '[Antrag] Load failed',

  ANTRAG_SAVE = '[Antrag] Save',
  ANTRAG_SAVE_SUCCESS = '[Antrag] Save success',

  ANTRAG_CREATE = '[Antrag] Create',
  ANTRAG_CREATE_SUCCESS = '[Antrag] Create success',
  ANTRAG_CREATE_FAILED = '[Antrag] Create failed',

  ANTRAG_RESET = '[Antrag] Reset',

}

export class AntragLoadAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_LOAD;

  constructor(public payload: string) {
  }
}

export class AntragLoadSuccessAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_LOAD_SUCCESS;

  constructor(public payload: Antrag) {
  }
}

export class AntragLoadFailedAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_LOAD_FAILED;
}

export class AntragCreateAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_CREATE;

  constructor(public payload: {bgNummer: string, formVersion: number}) {
  }
}

export class AntragCreateSuccessAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_CREATE_SUCCESS;

  constructor(public antrag: Antrag) {
  }
}

export class AntragCreateFailAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_CREATE_FAILED;
}

export class AntragSaveAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_SAVE;

  constructor(public payload: Antrag) {
  }
}

export class AntragSaveSuccessAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_SAVE_SUCCESS;
}

export class AntragResetAction implements Action {
  readonly type = AntragActionTypes.ANTRAG_RESET;

}

export type AntragActions =
  AntragLoadAction |
  AntragLoadSuccessAction |
  AntragCreateAction |
  AntragCreateSuccessAction |
  AntragCreateFailAction |
  AntragSaveAction |
  AntragSaveSuccessAction |
  AntragResetAction;

